import { useMemo } from "react";
import { PendingRequest, useDebouncedRequest } from "hooks/useDebouncedRequest";
import { MixCreate } from "store/api/generatedApi";

export type LayeringPreview = (mix: MixCreate) => PendingRequest<MixCreate>;

const checkLayering = ({
  mix,
  preview,
}: {
  mix: MixCreate;
  preview: LayeringPreview;
}) => preview(mix);

export const useLayeringPreview = ({
  mix,
  preview,
}: {
  mix: MixCreate;
  preview: LayeringPreview | undefined;
}) => {
  const request = useMemo(
    () => (preview === undefined ? null : { mix, preview }),
    [mix, preview]
  );
  const { completion, isCurrent, ...status } = useDebouncedRequest({
    request,
    check: checkLayering,
    delay: 300,
  });
  return {
    ...status,
    automaticMix:
      isCurrent && completion?.status === "success"
        ? completion.response
        : null,
  };
};
